export default "__VITE_ASSET__CxA0tuwH__"